import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { CheckText } from '../../../components/common/CheckText';
import { Hub } from '../../../components/common/Hub/Hub';
import { VirtualOfficePlan } from '../../../components/common/VirtualOfficeSubscription/VirtualOfficePlan';
import { P2 } from '../../../styles/FontStyles';
import { Button } from '../../../styles/GlobalComponents';
import { PurchaseSteps } from '../Maeketplace.types';
import { ErrorToast } from '../../../components';

export const VirtualOfficeSubscriptionStyled = styled.div`
  cursor: pointer;
  background: ${(props) => props.theme.colors.secondaryBlue};
  border-radius: 12px;
  padding: 20px;
  width: 100%;
  margin-bottom: 20px;
  @media (max-width: 800px) {
    padding: 16px;
  }
`;

interface InitialProps {
  setStep: Dispatch<SetStateAction<any>>;
  setModal: Dispatch<SetStateAction<boolean>>;
  selectedPackage: any;
  selectedLicence: any;
  setSelectedLicence: any;
  licenceDate: number;
  checkedLicence: boolean;
  setCheckedLicence: Dispatch<SetStateAction<boolean>>;
}

export const Initial = ({
  setStep,
  selectedPackage,
  setModal,
  selectedLicence,
  setSelectedLicence,
  licenceDate,
  checkedLicence,
  setCheckedLicence
}: InitialProps) => {
  const [checkbox, setCheckbox] = useState(false);
  const { t } = useTranslation('marketplace');

  const handleWithLicence = () => {
    setStep(PurchaseSteps.PAYMENT_METHOD);
  };

  const handleWithoutLicence = () => {
    setStep(PurchaseSteps.PAYMENT_METHOD);
    setSelectedLicence(null);
  };

  if (!selectedPackage?.id) return null;

  const amountToPay = selectedLicence
    ? selectedPackage?.subscriptionPrice
      ? selectedLicence.price +
        selectedPackage?.price +
        selectedPackage?.subscriptionPrice
      : selectedLicence.price + selectedPackage?.price
    : selectedPackage?.subscriptionPrice
    ? selectedPackage?.subscriptionPrice + selectedPackage?.price
    : selectedPackage?.price;
  return (
    <div>
      <VirtualOfficePlan
        selected={selectedLicence}
        setSelected={setSelectedLicence}
        checkedLicence={checkedLicence}
        setCheckedLicence={setCheckedLicence}
      />

      <P2 mt='20' mb='40'>
        {licenceDate === 0 ? (
          <div style={{ display: 'inline' }}>
            Your BigHearts Back Office subscription <b>has expired. </b>
          </div>
        ) : (
          <div style={{ display: 'inline' }}>
            {t('subscription_expiring')}{' '}
            <b>{t('next_days', { licenceDate })} </b>
          </div>
        )}
        {t('members_without_backoffice_text1')}
        <b> {t('members_without_backoffice_text2')} </b>{' '}
        {t('members_without_backoffice_text3')}
      </P2>

      <P2 mb='32'>
        {checkedLicence ? '✅' : '❌'} Full Bonuses (Direct Bonus)
      </P2>

      <P2 mt='40' mb='20' bold>
        {t('selected_staking_hub_nft')}:
      </P2>

      <Hub
        id={selectedPackage?.id}
        key={selectedPackage?.id}
        condensed
        image={selectedPackage?.imageUrl}
        title={selectedPackage?.name}
        price={checkedLicence ? amountToPay : selectedPackage?.price}
        subscriptionPrice={selectedPackage?.subscriptionPrice}
        selectedLicence={selectedLicence}
        subtitle={selectedPackage?.subtitle}
        tickets={selectedPackage?.tickets}
        packagePrice={selectedPackage?.price}
        weeklyCap={selectedPackage?.weeklyCap}
        limitedQuantity={selectedPackage?.limitedQuantity}
        dobuleTradingBinaries={selectedPackage?.tradingBinaryPercentage}
        includesSubscription={checkedLicence}
        willyMemeCoins={selectedPackage?.willyMemeCoins}
        info={<></>}
      />

      {!checkedLicence && (
        <CheckText
          checked={checkbox}
          onClick={() => setCheckbox(!checkbox)}
          text={t('checkbox_confirm')}
        />
      )}

      <Button
        mt={16}
        onClick={handleWithLicence}
        disabled={!checkedLicence && !checkbox}>
        {checkedLicence ? t('continue_with_subscription') : 'Continue'}
      </Button>
    </div>
  );
};
